import React from 'react';
import BottomButtonsNew from '../../shared/BottomButtonsNew/BottomButtonsNew';
import { DiscoverHappyParty } from '../../constants/assets'; // DiscoverSphere, 

const PrizesList = props => {
    const goToNext = () => {
        const { history } = props;
        history.push("/play");
    }

    return (
        <div className="prizes-list-page text-center">
            { /* <DiscoverSphere /> */ }
            <h1 className="font-sep">Descubre</h1>
            <p>
                Recetas y postales digitales para compartir con los tuyos, y participa para
                ganar boletos dobles de cine, libros de cocina y kits de productos La Moderna®.
            </p>
            <DiscoverHappyParty />
            <BottomButtonsNew btn1={{
                btnAction: goToNext,
                customClass: 'next-button-new'
            }} />
            { /*
            <DiscoverGift />
            <BottomButtons btn1={{
                btnAction: goToNext,
                customClass: 'next-button'
            }} />
            */ }
        </div>
    );
};

export default PrizesList;
